import React from 'react';
import ReactDOM from 'react-dom';

interface FeedbackEditorPopoverProps {
  open: boolean;
  position: { top: number; left: number } | null;
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
  title?: string;
  placeholder?: string;
  fontFamily?: string;
  borderColor?: string;
  backgroundColor?: string;
  titleColor?: string;
  cancelColor?: string;
  cancelBorderColor?: string;
  saveColor?: string;
  saveBorderColor?: string;
  saveBackgroundColor?: string;
}

const FeedbackEditorPopover: React.FC<FeedbackEditorPopoverProps> = ({
  open,
  position,
  value,
  onChange,
  onClose,
  onSave,
  title = 'Edit Feedback',
  placeholder = 'Add your feedback here...',
  fontFamily,
  borderColor = 'var(--border-glass, rgba(255,255,255,0.09))',
  backgroundColor = '#1e1e35',
  titleColor = 'var(--text-primary)',
  cancelColor = 'var(--text-secondary)',
  cancelBorderColor,
  saveColor = '#a78bfa',
  saveBorderColor,
  saveBackgroundColor = 'rgba(139,92,246,0.16)',
}) => {
  if (!open || !position) return null;

  return ReactDOM.createPortal(
    <>
      <div
        style={{ position: 'fixed', inset: 0, zIndex: 10049, background: 'transparent' }}
        onClick={onClose}
      />
      <div
        style={{
          position: 'fixed',
          top: position.top,
          left: position.left,
          zIndex: 10050,
          width: 420,
          borderRadius: 10,
          border: `1px solid ${borderColor}`,
          background: backgroundColor,
          boxShadow: '0 12px 40px rgba(0,0,0,0.35)',
          padding: 14,
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ fontSize: 13, fontWeight: 600, color: titleColor, fontFamily, marginBottom: 10 }}>
          {title}
        </div>
        <textarea
          autoFocus
          className="glass-input"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && e.ctrlKey) onSave();
            else if (e.key === 'Escape') onClose();
          }}
          style={{ width: '100%', fontSize: 13, fontFamily, marginBottom: 12, minHeight: 120, resize: 'vertical', padding: '8px 10px', boxSizing: 'border-box' }}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            onClick={onClose}
            style={{
              fontSize: 12,
              fontFamily,
              padding: '6px 12px',
              borderRadius: 6,
              border: `1px solid ${cancelBorderColor || borderColor}`,
              background: 'none',
              color: cancelColor,
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            style={{
              fontSize: 12,
              fontFamily,
              padding: '6px 12px',
              borderRadius: 6,
              border: `1px solid ${saveBorderColor || borderColor}`,
              background: saveBackgroundColor,
              color: saveColor,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >
            Save
          </button>
        </div>
      </div>
    </>,
    document.body,
  );
};

export default FeedbackEditorPopover;
